export default {
  loading: false,
  schoolYears: [],
  schoolYear: {},
  statistics: {},
}
